// extracted by mini-css-extract-plugin
module.exports = {"container":"i_Pe","image":"i_Pf","wrapper":"i_Pg","content":"i_Ph","body":"i_Pi","footer":"i_Pj","action":"i_Pk","title":"i_Pl","label":"i_Pm"};